module.exports = __webpack_public_path__ + "static/media/엽서섬네일 (9).458c366f.PNG";